import { render, staticRenderFns } from "./FBAOrder.vue?vue&type=template&id=98346978&scoped=true&"
import script from "./FBAOrder.vue?vue&type=script&lang=js&"
export * from "./FBAOrder.vue?vue&type=script&lang=js&"
import style0 from "./FBAOrder.vue?vue&type=style&index=0&id=98346978&scoped=true&lang=css&"
import style1 from "./FBAOrder.vue?vue&type=style&index=1&lang=css&"
import style2 from "./FBAOrder.vue?vue&type=style&index=2&id=98346978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98346978",
  null
  
)

export default component.exports